"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Amplitude = require("./Amplitude");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function Error(_ref) {
  var children = _ref.children,
      pageName = _ref.pageName;
  if (!children) return null;
  (0, _Amplitude.logAmplitudeEvent)("Displayed On-Page Error", {
    page: pageName,
    errorMsg: children
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert alert-danger",
    style: {
      border: "1px solid #f5c6cb",
      borderRadius: "2px",
      backgroundColor: "#f8d7da",
      color: "#721c24"
    }
  }, children);
}

var _default = Error;
exports["default"] = _default;